<template>
  <div>
    <div class="padding-sm">
      <span>白色背景：店铺根据等级设置的价格,可以修改</span><br/>
      <span>灰色背景：店铺根据等级设置的价格,不可修改</span><br/>
      <span>蓝色背景：店员自定义的价格</span>
    </div>
    <table class="price-table">
      <tr class="header">
        <th colspan="3" id="header1">服务项目</th>
        <th id="header2">价格</th>
      </tr>
      <template v-for="(item1, index1) in itemList[0]">
        <template v-if="itemList[item1.id]">
          <template v-for="(item2, index2) in itemList[item1.id]">
            <template v-if="itemList[item2.id]">
              <template v-for="(item3, index3) in itemList[item2.id]">
                <tr class="tr" :key="index1 +'_'+ index2 +'_'+ index3">
                  <td v-if="index2 == 0 && index3 == 0" :rowspan="getItemChildrenCount(item1.id)" class="level-1">
                    {{ item1.name }}
                  </td>
                  <td v-if="index3 == 0" :rowspan="getItemChildrenCount(item2.id)">{{ item2.name }}</td>
                  <td>{{ item3.name }}</td>
                  <td class="price" :class="{disabled: !item3.clerkPriceSwitch,changed:clerkPrice[item3.id] !== shopPrice[item3.id]}" @click="onPriceClick(item3)">
                    {{ formatPrice(clerkPrice[item3.id]) }}
                  </td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr class="tr" :key="index1 +'_'+ index2">
                <td v-if="index2 == 0" :rowspan="getItemChildrenCount(item1.id)" class="level-1">{{ item1.name }}</td>
                <td colspan="2">{{ item2.name }}</td>
                <td class="price" :class="{disabled: !item2.clerkPriceSwitch,changed:clerkPrice[item2.id] !== shopPrice[item2.id]}" @click="onPriceClick(item2)">
                  {{ formatPrice(clerkPrice[item2.id]) }}
                </td>
              </tr>
            </template>
          </template>
        </template>
        <template v-else>
          <tr class="tr" :key="index1">
            <td class="level-1">{{ item1.name }}</td>
            <td class="empty"></td>
            <td class="empty"></td>
            <td class="price" :class="{disabled: !item1.clerkPriceSwitch,changed:clerkPrice[item1.id] !== shopPrice[item1.id]}" @click="onPriceClick(item1)">
              {{ formatPrice(clerkPrice[item1.id]) }}
            </td>
          </tr>
        </template>
      </template>
    </table>
    <van-dialog v-if="editDialog.item" v-model="editDialog.show" title="自定义服务价格" show-cancel-button
                :before-close="onConfirm">
      <van-cell-group :border="false">
        <van-cell title="服务名称" :value="editDialog.itemFullName" :border="false"/>
        <van-cell title="店铺价格" :value="formatPrice(shopPrice[editDialog.item.id])" :border="false"/>
        <van-field v-model="editDialog.itemPrice"  label="自定义价格" placeholder="填空则与店铺价格一致" type="number"
                   :error-message="`可设置的价格范围：${formatPrice(editDialog.item.clerkPriceMin)} - ${formatPrice(editDialog.item.clerkPriceMax)}`"
                   error-message-align="right" input-align="right" :border="false"/>

      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import Decimal from "decimal.js";
import Vue from 'vue';
import {Cell, CellGroup, Field, Form, Icon, Toast} from 'vant';
import {handlePromise} from "@/libs/util";
import {listItemPrice, updateClerkPrice} from "@/api/clerk/item";
import _ from 'lodash'

Vue.use(Cell)
    .use(CellGroup)
    .use(Field)
    .use(Form)
    .use(Icon)
    .use(Toast);
export default {
  name: "item-price",
  data() {
    return {
      tableBorder: "none;2px #f5f5f5 solid",
      headBorder1: "none;2px #f5f5f5 solid;2px #f5f5f5 solid",
      headBorder2: "none;2px #f5f5f5 solid",
      tableColor: "#000",
      tableFontSize: "14px",
      tableWeight: "normal;bold;bold;bold",
      textAlign: "center",
      tableHeight: "30px",
      tableBackground: "white",
      itemMap: null,
      itemList: {},
      shopPrice: {},
      clerkPrice: {},
      editDialog: {
        show: false,
        item: null,
        itemFullName: null,
        itemPrice: null
      }
    }
  },
  methods: {
    loadData() {
      handlePromise(listItemPrice(), (data) => {
        let itemList = data.itemList
        let itemMap = new Map()
        _.forIn(itemList, (elem => {
          for (let i = 0; i < elem.length; i++) {
            itemMap.set(elem[i].id, elem[i])
          }
        }))
        this.itemList = itemList
        this.itemMap = itemMap
        this.shopPrice = data.shopPrice
        this.clerkPrice = data.clerkPrice
      })
    },
    onConfirm(action, done) {
      if ('confirm' === action) {
        let itemPrice =  this.editDialog.itemPrice
        if (!/^\d+(\.\d{1,2})?$/.test(itemPrice)) {
          Toast.fail('格式错误')
          return done(false)
        }
        itemPrice = Decimal.mul(Number(itemPrice),100).toNumber()
        if ( itemPrice!== 0 && (itemPrice < this.editDialog.item.clerkPriceMin || itemPrice > this.editDialog.item.clerkPriceMax)) {
          Toast.fail('请输入范围内的价格')
          done(false)
          return
        }
        Toast.loading()
        handlePromise(updateClerkPrice(this.editDialog.item.id,itemPrice>0?itemPrice:null),()=>{
          Toast.success('修改成功')
        },null,()=>{
          Toast.clear()
          this.loadData()
        })
      }
      done()

    },
    getItemFullName(item) {
      let name = item.name;
      while (item.parentId !== 0) {
        item = this.itemMap.get(item.parentId)
        name = item.name + '-' + name;
      }
      return name
    },
    onPriceClick(item) {
      if (item.clerkPriceSwitch) {
        this.editDialog.item = item
        this.editDialog.itemFullName = this.getItemFullName(item)
        if(this.clerkPrice[item.id] === this.shopPrice[item.id]){
          this.editDialog.itemPrice = null
        }else{
          this.editDialog.itemPrice = Decimal.div(this.clerkPrice[item.id], 100).toNumber()
        }
        this.editDialog.show = true;
      } else {
        Toast.clear()
        Toast('该服务价格不可修改')
      }


    },
    getItemChildrenCount(itemId, count) {
      count = count || 0
      if (this.itemList[itemId]) {
        for (const item of this.itemList[itemId]) {
          if (this.itemList[item.id]) {
            count = this.getItemChildrenCount(item.id, count)
          } else {
            count += 1
          }
        }
      }
      return count
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
  },
  mounted() {
    this.loadData()
  },
  updated() {
    //如需传入多个参数请用;隔开

    //圆角
    //可接受两个参数
    //一个参数，改变整个表格圆角
    //两个参数，第一个参数改变上面两个圆角，第二个参数改变下面两个圆角
    if (this.radius) {
      document.getElementById("header1").style.borderTopLeftRadius = this.radius
      document.getElementById("header2").style.borderTopRightRadius = this.radius
      document.getElementsByTagName("table")[0].style.borderBottomLeftRadius = this.radius
      document.getElementsByTagName("table")[0].style.borderBottomRightRadius = this.radius
      if (this.radius.includes(';')) {
        let r = this.radius.split(";")
        document.getElementById("header1").style.borderTopLeftRadius = r[0]
        document.getElementById("header2").style.borderTopRightRadius = r[0]
        document.getElementsByTagName("table")[0].style.borderBottomLeftRadius = r[1]
        document.getElementsByTagName("table")[0].style.borderBottomRightRadius = r[1]
      }
    }
    //表体边框以及格子边框（不包括表头）
    //可接受两个参数
    //一个参数，改变表体和格子边框
    //两个参数，第一个参数改变表体边框，第二个参数改变格子边框
    if (this.tableBorder) {
      let l1 = document.getElementsByClassName("level-1")
      let price = document.getElementsByClassName("price")
      let table = document.getElementsByTagName("table")[0]
      let td = document.getElementsByTagName("td")
      let td2 = document.getElementsByTagName("tr")[1].children

      if (this.tableBorder.includes(';')) {
        let t = this.tableBorder.split(";")
        for (let i = 0; i < td.length; i++) {
          td[i].style.borderRight = t[1]
          td[i].style.borderTop = t[1]
        }
        for (let i = 0; i < l1.length; i++) {
          l1[i].style.borderLeft = t[0]
        }
        for (let i = 0; i < price.length; i++) {
          price[i].style.borderRight = t[0]
        }
        table.style.borderBottom = t[0]

        let none = "none"
        for (let i = 0; i < td2.length; i++) {
          td2[i].style.borderTop = none
        }
      } else {
        for (let i = 0; i < l1.length; i++) {
          l1[i].style.borderLeft = this.tableBorder
        }
        for (let i = 0; i < price.length; i++) {
          price[i].style.borderRight = this.tableBorder
        }
        table.style.borderBottom = this.tableBorder
        for (let i = 0; i < td.length; i++) {
          td[i].style.borderRight = this.tableBorder
          td[i].style.borderTop = this.tableBorder
        }
        let none = "none"
        for (let i = 0; i < td2.length; i++) {
          td2[i].style.borderTop = none
        }
      }
    }
    //表头1边框
    //可接受三个参数
    //一个参数，改变整个边框
    //两个参数，第一个参数改变上左边框，第二个参数改变下边框
    //三个参数，第一个参数改变上左边框，第二个参数改变下边框，第三个参数改变右边框
    if (this.headBorder1) {
      let header1 = document.getElementById("header1")
      if (this.headBorder1.includes(';')) {
        let h = this.headBorder1.split(";")
        if (h.length == 2) {
          header1.style.borderLeft = h[0]
          header1.style.borderTop = h[0]
          header1.style.borderBottom = h[1]
        } else if (h.length == 3) {
          header1.style.borderLeft = h[0]
          header1.style.borderTop = h[0]
          header1.style.borderBottom = h[1]
          header1.style.borderRight = h[2]
        }
      } else {
        header1.style.border = this.headBorder1
      }
    }
    //表头2边框
    //可接受两个参数
    //一个参数，改变上右下边框
    //两个参数，第一个参数改变上右边框，第二个参数改变下边框
    if (this.headBorder2) {
      let header2 = document.getElementById("header2")
      if (this.headBorder2.includes(';')) {
        let h = this.headBorder2.split(";")
        header2.style.borderRight = h[0]
        header2.style.borderTop = h[0]
        header2.style.borderBottom = h[1]
      } else {
        header2.style.borderRight = this.headBorder1
        header2.style.borderTop = this.headBorder1
        header2.style.borderBottom = this.headBorder1
      }
    }
    //表格背景色
    //可接受三个参数
    //一个参数，改变整个表格
    //两个参数，第一个参数改变表体，第二个参数改变表头
    //三个参数，第一个参数改变表体，第二个参数改变表头左，第三个参数改变表头右
    if (this.tableBackground) {
      let td = document.getElementsByTagName("td")
      let header1 = document.getElementById("header1")
      let header2 = document.getElementById("header2")

      if (this.tableBackground.includes(';')) {
        let t = this.tableBackground.split(";")
        if (t.length == 2) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.background = t[0]
          }
          header1.style.background = t[1]
          header2.style.background = t[1]
        } else if (t.length == 3) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.background = t[0]
          }
          header1.style.background = t[1]
          header2.style.background = t[2]
        }
      } else {
        for (let i = 0; i < td.length; i++) {
          td[i].style.background = this.tableBackground
        }
        header1.style.background = this.tableBackground
        header2.style.background = this.tableBackground
      }
    }
    //表格字体颜色
    //可接受三个参数
    //一个参数，改变整个表格
    //两个参数，第一个参数改变表体，第二个参数改变表头
    //三个参数，第一个参数改变表体，第二个参数改变表头左，第三个参数改变表头右
    if (this.tableColor) {
      let td = document.getElementsByTagName("td")
      let header1 = document.getElementById("header1")
      let header2 = document.getElementById("header2")

      if (this.tableColor.includes(';')) {
        let t = this.tableColor.split(";")
        if (t.length == 2) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.color = t[0]
          }
          header1.style.color = t[1]
          header2.style.color = t[1]
        } else if (t.length == 3) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.color = t[0]
          }
          header1.style.color = t[1]
          header2.style.color = t[2]
        }
      } else {
        for (let i = 0; i < td.length; i++) {
          td[i].style.color = this.tableColor
        }
        header1.style.color = this.tableColor
        header2.style.color = this.tableColor
      }
    }
    //表格字体大小
    //可接受四个参数
    //一个参数，改变整个表格
    //两个参数，第一个参数改变表体，第二个参数改变表头
    //三个参数，第一个参数改变表体，第二个参数改变表头左，第三个参数改变表头右
    //四个参数，第一个参数改变表体，第二个参数改变表头左，第三个参数改变表头右，第四个参数改变表体左侧标题
    if (this.tableFontSize) {
      let td = document.getElementsByTagName("td")
      let header1 = document.getElementById("header1")
      let header2 = document.getElementById("header2")
      let l1 = document.getElementsByClassName("level-1")

      if (this.tableFontSize.includes(';')) {
        let t = this.tableFontSize.split(";")
        if (t.length == 2) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.fontSize = t[0]
          }
          header1.style.fontSize = t[1]
          header2.style.fontSize = t[1]
        } else if (t.length == 3) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.fontSize = t[0]
          }
          header1.style.fontSize = t[1]
          header2.style.fontSize = t[2]
        } else if (t.length == 4) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.fontSize = t[0]
          }
          header1.style.fontSize = t[1]
          header2.style.fontSize = t[2]
          for (let i = 0; i < l1.length; i++) {
            l1[i].style.fontSize = t[3]
          }
        }
      } else {
        for (let i = 0; i < td.length; i++) {
          td[i].style.fontSize = this.tableFontSize
        }
        header1.style.fontSize = this.tableFontSize
        header2.style.fontSize = this.tableFontSize
      }
    }
    //表格字体粗细
    //可接受四个参数
    //一个参数，改变整个表格
    //两个参数，第一个参数改变表体，第二个参数改变表头
    //三个参数，第一个参数改变表体，第二个参数改变表头左，第三个参数改变表头右
    //四个参数，第一个参数改变表体，第二个参数改变表头左，第三个参数改变表头右，第四个参数改变表体左侧标题
    if (this.tableWeight) {
      let td = document.getElementsByTagName("td")
      let header1 = document.getElementById("header1")
      let header2 = document.getElementById("header2")
      let l1 = document.getElementsByClassName("level-1")

      if (this.tableWeight.includes(';')) {
        let t = this.tableWeight.split(";")
        if (t.length == 2) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.fontWeight = t[0]
          }
          header1.style.fontWeight = t[1]
          header2.style.fontWeight = t[1]
        } else if (t.length == 3) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.fontWeight = t[0]
          }
          header1.style.fontWeight = t[1]
          header2.style.fontWeight = t[2]
        } else if (t.length == 4) {
          for (let i = 0; i < td.length; i++) {
            td[i].style.fontWeight = t[0]
          }
          header1.style.fontWeight = t[1]
          header2.style.fontWeight = t[2]
          for (let i = 0; i < l1.length; i++) {
            l1[i].style.fontWeight = t[3]
          }
        }
      } else {
        for (let i = 0; i < td.length; i++) {
          td[i].style.fontWeight = this.tableWeight
        }
        header1.style.fontWeight = this.tableWeight
        header2.style.fontWeight = this.tableWeight
      }
    }
    //文本对齐方式
    //可接受两个参数：一个参数，改变整个表格。两个参数，第一个参数改变表体，第二个参数改变表头
    if (this.textAlign) {
      let td = document.getElementsByTagName("td")
      let header1 = document.getElementById("header1")
      let header2 = document.getElementById("header2")
      if (this.textAlign.includes(';')) {
        let t = this.textAlign.split(";")
        for (let i = 0; i < td.length; i++) {
          td[i].style.textAlign = t[0]
        }
        header1.style.textAlign = t[1]
        header2.style.textAlign = t[1]
      } else {
        for (let i = 0; i < td.length; i++) {
          td[i].style.textAlign = this.textAlign
        }
        header1.style.textAlign = this.textAlign
        header2.style.textAlign = this.textAlign
      }
    }
    //高度
    //可接受两个参数：一个参数，改变整个表格。两个参数，第一个参数改变表体，第二个参数改变表头
    if (this.tableHeight) {
      let td = document.getElementsByTagName("td")
      let header1 = document.getElementById("header1")
      let header2 = document.getElementById("header2")
      if (this.tableHeight.includes(';')) {
        let t = this.tableHeight.split(";")
        for (let i = 0; i < td.length; i++) {
          td[i].style.height = t[0]
        }
        header1.style.height = t[1]
        header2.style.height = t[1]
      } else {
        for (let i = 0; i < td.length; i++) {
          td[i].style.height = this.tableHeight
        }
        header1.style.height = this.tableHeight
        header2.style.height = this.tableHeight
      }
    }
    //背景图片
    //可接受三个参数：图片路径(必填) 图片尺寸(100% 100%) 重复方式(no-repeat)
    if (this.tableImg) {
      let table = document.getElementsByTagName("table")[0]
      if (this.tableImg.includes(';')) {
        let t = this.tableImg.split(";")
        if (t.length == 2) {
          table.style.backgroundImage = "url('" + t[0] + "')"
          table.style.backgroundSize = t[1]
          table.style.backgroundRepeat = "no-repeat"
        } else if (t.length == 3) {
          table.style.backgroundImage = "url('" + t[0] + "')"
          table.style.backgroundSize = t[1]
          table.style.backgroundRepeat = t[2]
        }
      } else {
        table.style.backgroundImage = "url('" + this.tableImg + "')"
        table.style.backgroundSize = "100% 100%"
        table.style.backgroundRepeat = "no-repeat"
      }
    }

    let disabledElements = document.getElementsByClassName("disabled");
    for (let i = 0; i < disabledElements.length; i++) {
      disabledElements[i].style.backgroundColor = "#f1efef"
    }
    let changedElements = document.getElementsByClassName("changed");
    for (let i = 0; i < changedElements.length; i++) {
      changedElements[i].style.backgroundColor = "#e8f7ff"
    }
  }
}
</script>

<style lang="less">
table {
  position: relative;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  overflow: hidden;
}

td {
  height: 30px;
  padding: 0 5px;
  text-align: center;
}

th {
  height: 30px;
  font-weight: normal;
}

tr > td:last-child {
  border-right: none;
}

table tr:nth-child(2) td {
  border-top: none;
}

#header1 {
  padding: 0 5px;
  text-align: center;
}

#header2 {
  padding: 0 5px;
  text-align: center;
}

.price-remark {
  margin-top: 10px;

  /deep/ img {
    vertical-align: middle;
  }
}
</style>
